import React from 'react';

export interface SegmentOption<T extends string> {
  value: T;
  label: string;
  /** Подсказка при наведении — у коротких подписей вроде «%» и «₸». */
  title?: string;
}

interface SegmentedProps<T extends string> {
  /** Имя группы для скринридера: что именно переключается. */
  label: string;
  value: T;
  options: Array<SegmentOption<T>>;
  onChange: (value: T) => void;
  disabled?: boolean;
  /** Единица рядом с числом («%» / «₸»): крупнее и с заливкой. */
  unit?: boolean;
}

/**
 * Переключатель из двух-трёх вариантов одной рамкой. Кнопки с
 * `aria-pressed` — тот же приём, что у чипов дней недели.
 */
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange,
  disabled = false,
  unit = false,
}: SegmentedProps<T>) {
  return (
    <div className={`qp-seg${unit ? ' qp-seg--unit' : ''}`} role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="qp-seg-btn"
          aria-pressed={value === option.value}
          title={option.title}
          onClick={() => onChange(option.value)}
          disabled={disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
